// extracted by mini-css-extract-plugin
export default {"main":"Arrow_main__vxJ-t","main_type_left":"Arrow_main_type_left__itdNk","main_type_right":"Arrow_main_type_right__MbL1Y"};